

import React, { useState, useRef, useEffect } from 'react';
import { Box, Button, Typography, TextField, IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
// import CustomInput from '../CustomInput/CustomInput';
import CustomInputLogin from '../../Components/CustomInputLogin/CustomInputLogin';

const generateCaptchaText = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // Avoids O, 0, I, 1
    return Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
};

const drawCaptcha = (text, canvasRef) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = 200;
    canvas.height = 50;

    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.7)`;
        ctx.lineWidth = Math.random() * 2;
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.stroke();
    }

    ctx.font = "bold 30px Arial";
    ctx.textBaseline = "middle";
    for (let i = 0; i < text.length; i++) {
        const x = 30 + i * 25;
        const y = 30 + Math.random() * 10 - 5;
        const angle = (Math.random() * 20 - 10) * (Math.PI / 180);

        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.fillStyle = `rgb(${Math.random() * 150}, ${Math.random() * 150}, ${Math.random() * 150})`;
        ctx.fillText(text[i], 0, 0);
        ctx.restore();
    }
};

const AdminSignInForm = ({ handleSubmit, toggleForgotPassword, handleGoRegistrationPage }) => {


    const validationSchema = Yup.object({
        email: Yup.string().email('Invalid email').required('Email is required'),
        password: Yup.string().required('Password is required'),
        // captcha: Yup.string().required('CAPTCHA is required')
    });

    return (
        <Formik
            initialValues={{
                email: '',
                password: ''

            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setFieldError }) => {
                // if (values.captcha.toUpperCase() !== captchaText) {
                //     setFieldError("captcha", "CAPTCHA is incorrect. Try again.");
                //     refreshCaptcha();
                // } else {
                //     handleSubmit(values);

                // }
                handleSubmit(values);

            }}
        >
            {({ errors, touched, handleChange }) => (
                <Form style={{ width: '100%' }}>
                    <Box mb={1}>
                        <CustomInputLogin name="email" label="Email" custPlaceholder="Enter Email" inputType="text" />
                    </Box>

                    <Box mt={2}>
                        <CustomInputLogin name="password" label="Password" custPlaceholder="Enter Password" inputType="password" />
                    </Box>





                    <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        sx={{
                            mt:4,
                            // borderRadius: 23,
                            py: "7px",
                            color: "white",
                            backgroundColor: "var(--main-color)"
                        }}
                    >
                        Sign In
                    </Button>


                </Form>
            )
            }
        </Formik >
    );
};

export default AdminSignInForm;
